<template lang="pug">
  div
    label(
      for="percent"
      v-if="label !== ''"
    )
      | {{ label }}
    masked-input.form__input(
      type="text"
      name="percent"
      class="form-control"
      v-model="value"
      :mask="[/[1-9]/, /[0-9]/, /[0-9]/]"
      :guide="false"
      :placeholder="placeholder"
      @input="onChange"
    )
</template>

<script>
import MaskedInput from 'vue-text-mask';

export default {
  props: {
    initialValue: {
      required: true,
      type: String
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    placeholder: {
      required: false,
      type: String,
      default: '%'
    }
  },

  data() {
    return {
      value: ''
    };
  },

  mounted() {
    this.value = String(this.initialValue);
    this.emitInput();
  },

  methods: {
    onChange() {
      this.emitInput();
    },

    emitInput() {
      this.$emit('input', this.value);
      this.$emit('percent-input', this.value);
    }
  },

  watch: {
    initialValue: function(newVal, oldVal) {
      console.log(newVal, oldVal);
      this.value = String(newVal);
      this.emitInput();
    }
  },

  components: {
    MaskedInput
  }
};
</script>
